import { render, staticRenderFns } from "./AnnualBarGraph.vue?vue&type=template&id=661f8d35&"
import script from "./AnnualBarGraph.vue?vue&type=script&lang=js&"
export * from "./AnnualBarGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports